<template>
  <div>
    <v-row>
        <v-col cols="12" xs="12" sm="8" style="text-align: justify;">
        {{$t('page.series.group-option-title-1')}}<br/>
        {{$t('page.series.group-option-title-2')}}<br/>
        {{$t('page.series.group-option-title-3')}}<br/>
        {{$t('page.series.group-option-title-4')}}
        </v-col>
    </v-row>
    <p></p>
    <v-data-table 
      :headers="headers" 
      :items="rows" 
      class="elevation-1 ma-0 tableCust1"
      :footer-props="{
        'items-per-page-text': $t('dataTable.rowsPerPageText'),
        'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
      }"
      :no-data-text="$t('dataTable.noDataText')"
      :headerProps="{
        'sort-by-text': $t('dataTable.sortByText')
      }"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-dialog v-model="dialog" max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn-toggle dense>
                <v-btn color="primary" dark class="mb-2 primary" v-on="on" @click="newItem" :disabled="seriesSelected ? false : true">
                  <v-icon left dark>fa-plus</v-icon>
                  {{ $t('common.form.add') }}
                </v-btn> &nbsp;&nbsp;
                <v-btn color="primary" dark class="mb-2 primary" v-on="on" @click="importItem" :disabled="seriesSelected ? false : true">
                  <v-icon left dark>far fa-file-import</v-icon>
                  {{ $t('common.form.import') }}
                </v-btn>
              </v-btn-toggle>
            </template>
            <v-card class="borderDialog">
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-form ref="formSP" class="pt-4 inputSeries" >
                  <v-row>
                    <v-col cols="12">
                    <v-text-field v-if="editorType == 'new' || editorType == 'edit'"
                      v-model="input.points"
                      ref="inputPoints"
                      :label="$t('page.series.points')"
                      required
                      outlined dense
                      type="number"
                      :rules="[
                        (v) => $inputRules({value: v}, 'integer') || $t('page.series.points-invalid')
                      ]"
                      onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight','Tab'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                      min="0"
                      @keyup.enter="pressEnter"
                    ></v-text-field>
                    <v-text-field v-if="editorType == 'new' || editorType == 'edit'"
                      v-model="input.label"
                      ref="inputLabel"
                      :label="$t('page.series.label')"
                      required
                      outlined dense
                      :rules="[
                          (v) => $inputRules({value: v, minSize: 1, maxSize: 255}, 'fieldLength') || $t('page.series.label-invalid')
                      ]"
                      @keyup.enter="pressEnter"
                    ></v-text-field>
                    <v-select v-if="(editorType == 'new' || editorType == 'edit')"
                      v-model="input.positionShift"
                      :items="disableForSeriesItems"
                      item-text="text"
                      item-value="id"
                      ref="disableForSeriesItems"
                      :label="$t('page.series.position-shift')"
                      outlined dense
                      required
                      :rules="[ v => !!v || $t('page.series.position-shift-required')]"
                      @keyup.enter="pressEnter"
                      :no-data-text="$t('common.no_data')"
                    ></v-select>
                    <v-select v-if="editorType == 'new' || editorType == 'edit'"
                      v-model="input.group"
                      :items="input.groupItems"
                      item-text="text"
                      item-value="value"
                      ref="groupItems"
                      :label="$t('page.series.group-name')"
                      outlined dense
                      required
                      @keyup.enter="pressEnter"
                      :no-data-text="$t('common.no_data')"
                    ></v-select>
                    <v-select v-if="editorType == 'import'"
                      :key="keySeries"
                      v-model="seriesModel"
                      :items="seriesItems"
                      ref="selectInput"
                      outlined dense
                      required
                      :rules="[ v => !!v || $t('page.series.series-required')]"
                      @keyup.enter="importGroupOptions"
                      :no-data-text="$t('common.no_data')"
                    ></v-select>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" small text @click="close">{{ $t('common.form.cancel') }}</v-btn>
                <v-btn v-if="editorType == 'new'" color="blue darken-1" small text @click="create">{{ $t('common.form.create') }}</v-btn>
                <v-btn v-if="editorType == 'edit'" color="blue darken-1" small text @click="save">{{ $t('common.form.update') }}</v-btn>
                <v-btn v-if="editorType == 'import'" color="blue darken-1" @click="importGroupOptions" small text>{{ $t('common.form.import') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small @click="confirmDelete(item)">mdi-delete</v-icon>
      </template>
      <template v-slot:item.isPositionShift="{ item }">
          <td v-if="item.isPositionShift == 1">{{ $t("page.series.display-series-online-items.yes") }}</td>
          <td v-if="item.isPositionShift == 0">{{ $t("page.series.display-series-online-items.no") }}</td>
      </template>
      <template v-slot:item.groupName="{ item }">
          <td v-if="!item.groupName" class="text-start">{{ $t("page.series.overall") }}</td>
          <td v-else class="text-start">{{ item.groupName }}</td>
      </template>
    </v-data-table>
      <SGSNotificationConfirm v-if="dialogNotification" :notificationMessage="$t('common.confirm-delete')" 
      @cancel="dialogNotification=false;" @agree="deleteItem" type='warning' :acept="$t('common.form.delete')" :reject="$t('common.form.cancel')"/>
      <SGSNotificationAlert v-if="dialogAlert" :notificationMessage="alertMessage" @cancel="closeAlert" type='error'/>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import { mapState } from "vuex";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import SGSNotificationAlert from "@/components/custom/notification/NotificationAlert.vue";
import { YES_NO_OPTIONS } from "@/constants/selectOptions";

export default {
  mixins: [apiCalls],
  properties: [],
  components: {
    SGSNotificationConfirm,
    SGSNotificationAlert
  },
  data() {
    return {
      input: {
        class: null,
        group: null,
        groupItems: [],
        positionShift: null,
        eventsToCount: null,
        sortOrder: null
      },
      dialogNotification: false,
      alertMessage: '',
      dialogAlert: false,
      seriesModel: null,
      seriesItems: [],
      dialog: false,
      importDialog: true,
      reopenEdition: false,
      keySeries:0,
      bam: false,
      rows: [],
      groupsAll:[],
      item: {
        id: "",
        name: 0
      },
      editorType: "new"
    };
  },
  computed: {
    ...mapState({
      seriesSelected: state => state.series.seriesSelected
    }),
    formTitle() {
      let title = ''

      if (this.editorType == "new") title = this.$t('page.series.add-group-option')
      if (this.editorType == "edit") title = this.$t('page.series.edit-group-option')
      if (this.editorType == "import") title = this.$t('page.series.import-group-option')
      
      return title
    },
    pointsRules: function() {
      const regInt = new RegExp('[0-9]+');
      return [ 
        (v) => (v || '').toString().length > 0 || (v != null && v.toString() == '0') || this.$t('page.series.points-required') ,
        (v) => {
          const auxV = v ? v.toString() : "";
          const resultInt = auxV.split(regInt).filter(el => el != "");
          return !(resultInt.length > 0) ? true : this.$t('page.series.points-invalid');
        }
      ];
    },
    headers() {
      return [
        {
          text: this.$t("page.series.points"),
          value: "points"
        },
        {
          text: this.$t("page.series.label"),
          value: "label"
        },
        {
          text: this.$t("page.series.position-shift"),
          value: "isPositionShift"
        },
         {
          text: this.$t("page.series.group"),
          value: "groupName"
        },
        {
          text: this.$t("common.table.actions"),
          value: "actions",
          sortable: false
        }
      ];
    },
    rules() {
      return {
        points: [
          val =>(val || "").length > 0 
        ],
        label: [
          val => (val || "").length > 0 || this.$t('page.series.label-required')
        ]
      };
    },
    disableForSeriesItems() { return YES_NO_OPTIONS(this);}
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  methods: {
    init(){
      this.getRecords();
    },
    pressEnter(){
      if(this.editorType == "edit"){
        this.save()
      }else{
        this.create()
      }
    },
    async getRecords()
    {
      this.getGroups();
      this.getSeries();

      const response = await this.api(
        'get',
        `/api/v1/promoter/series/groupOption/${this.seriesSelected.id}`
      );

      this.rows = [];
      if (!response || !response.success)
      {
        return;
      }
      const data = response.message.data;
      this.rows = data.map(element =>
      {
        return {
          id: element.id,
          points: element.points,
          label: element.label,
          isPositionShift: element.isPositionShift,
          groupName: element.groupName,
          fkGroupId: element.fkSeriesGroupId,
          actions: "actions"
        }
      })
    },
    async getSeries() {
      this.seriesItems=[];
      if(this.seriesSelected) {
        const response = await this.getApi(
          "/api/v1/promoter/series"
        );

        if (response != undefined) {
          for(var i = 0; i < response.length; i++){
            if(response[i].id == this.seriesSelected.id){
              continue;
            }
            this.seriesItems.push({
              text: response[i].seriesName,
              value: response[i].id
            });          
          }
          this.allSeries = response;
          this.keySeries++
        }
      }
    },
    async getGroups() {
      if(this.seriesSelected) {
        const response = await this.api(
          'get',
          `/api/v1/promoter/series/group/${this.seriesSelected.id}`
        );
        this.groupsAll = response.message.data

        this.input.groupItems = [];

        // We need an option called overall with a null value
        // If the group is empty, its overall
        this.input.groupItems.push({value: null, text: 'Overall'});

        response.message.data.forEach(element => {
          const item = { value: element.id, text: element.groupName };
          this.input.groupItems.push(item);
        });

        this.input.groupItems.sort((a,b) => a.text.localeCompare(b.text));

        this.input.groupItems.unshift({
          header: this.$t("page.series.groups")
        });
      }
    },
    resetForm(){
        this.input.label = null;
        this.input.points = null;
        this.input.positionShift = null;
        this.input.group = null;
        this.bam=false
    },
    setForm(item){
        this.input.id = item.id;
        this.input.label = item.label;
        this.input.points = item.points;
        this.input.group = item.fkGroupId;
        this.input.positionShift = item.isPositionShift;
        if(item.isPositionShift == 0){
          this.input.positionShift = 2;
        }
    },
    newItem() {
      this.getGroups();
      this.resetForm();
      this.bam=true
      this.editorType = "new";
      if(this.$refs.formSP)
        this.$refs.formSP.resetValidation();
    },
    importItem(){
      if(this.$refs.formSP)
        this.$refs.formSP.resetValidation();
      this.editorType = "import";
      this.dialog =  true
      this.getSeries();
    },
    editItem(item){
      this.resetForm();
      this.setForm(item);
      this.editorType = "edit";
      this.dialog = true;
      this.item.id = item.id;
    },
    confirmDelete(item){
      this.dialogNotification = true
      this.item = item
    },
    async deleteItem() 
    {
      const response = await this.api('DELETE', `/api/v1/promoter/series/groupOption/${this.item.id}`);      
      if(response != undefined){
        if(!response.success) {
          this.alertMessage = this.$t('page.series.error_general');
          if(Array.isArray(response.error) && response.error.length > 0) {
              this.alertMessage = this.$t('common.request.'+response.error[0]);
          } else if(typeof response.error == 'string') {
              this.alertMessage = this.$t('common.request.'+response.error)
          } else if(Array.isArray(response.message) && response.message.length > 0) {
              this.alertMessage = this.$t('common.request.'+response.message[0]);
          } else if(typeof response.message == 'string') {
              this.alertMessage = this.$t('common.request.'+response.message)
          }
          this.dialog = false;
          this.dialogAlert = true;
          return;
        }
        this.getRecords();
        this.close();
      } else {
          this.alertMessage = this.$t('page.series.error_general');
          this.dialog = false;
          this.dialogAlert = true;
      }
    },
    close() {
      this.dialog = false;
      this.dialogNotification = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async create(){
      if(this.$refs.formSP.validate()){
        if(this.input.positionShift == 2){
          this.input.positionShift = 0
        }
        let data = {};
        data.label = this.input.label; 
        data.fkSeriesGroupId = this.input.group;    
        data.points = this.input.points;    
        data.isPositionShift = this.input.positionShift;
        data.fkSeriesId = this.seriesSelected.id; 

        const response = await this.api("POST", "/api/v1/promoter/series/groupOption", data);
        
        if(response != undefined){
          if(response.error != undefined){
            this.alertMessage = this.$t('page.series.error_general');
            if(Array.isArray(response.error) && response.error.length > 0) {
              this.alertMessage = this.$t('common.request.'+response.error[0]);
            } else if(typeof response.error == 'string') {
              this.alertMessage = this.$t('common.request.'+response.error)
            }
            this.dialogAlert = true; 
            this.close();
            this.reopenEdition = true; 
            return false;
          } else if (!response.success && response.message) {
            this.alertMessage = this.$t('page.series.error_general');
            if(Array.isArray(response.message) && response.message.length > 0) {
              this.alertMessage = this.$t('common.request.'+response.message[0]);
            } else if(typeof response.message == 'string') {
              this.alertMessage = this.$t('common.request.'+response.message)
            }
            this.dialogAlert = true; 
            this.close();
            this.reopenEdition = true; 
            return false;
          }
          this.getRecords();
          this.close();
        } else { 
          this.alertMessage = this.$t('page.series.error_general');
          this.dialog = false;
          this.dialogAlert = true;
          this.reopenEdition = true; 
        }
      }
    },
    async importGroupOptions(){
      if(!this.$refs.formSP.validate()) {
        if(this.seriesModel == null || this.seriesModel == ''){
          this.$refs.selectInput.focus();
          return false;
        }
        return;
      }

      this.dialog = false

      let data = {
        seriesId: this.seriesSelected.id,
        targetSeriesId: this.seriesModel
      }

      const response = await this.api("POST", "/api/v1/promoter/series/groupOption/import", data);

      

      if(!response || !response.success)
      { 
          this.alertMessage = this.$t('page.series.error_general');
          if(response && Array.isArray(response.error) && response.error.length > 0) {
              this.alertMessage = this.$t('common.request.'+response.error[0]);
          } else if(response && typeof response.error == 'string') {
              this.alertMessage = this.$t('common.request.'+response.error)
          } else if(response && Array.isArray(response.message) && response.message.length > 0) {
              this.alertMessage = this.$t('common.request.'+response.message[0]);
          } else if(response && typeof response.message == 'string') {
              this.alertMessage = this.$t('common.request.'+response.message)
          }
          this.dialog = false;
          this.dialogAlert = true;
          this.reopenEdition = true;
          return;
      }
      this.getRecords();
      this.close();
    },
    async save() {

      if(this.$refs.formSP.validate()) {
        let data = {};
        data.id = this.input.id;
        data.label = this.input.label;
        data.fkSeriesGroupId = this.input.group;    
        data.points = this.input.points;    
        data.isPositionShift = this.input.positionShift;

        const response = await this.api("PUT", "/api/v1/promoter/series/groupOption", data);
        
        if(response != undefined){
          if(response.error != undefined){
            this.alertMessage = this.$t('page.series.error_general');
            if(Array.isArray(response.error) && response.error.length > 0) {
              this.alertMessage = this.$t('common.request.'+response.error[0], { field: this.$t('page.series.group_option') });
            } else if(typeof response.error == 'string') {
              this.alertMessage = this.$t('common.request.'+response.error, { field: this.$t('page.series.group_option') })
            }
            this.dialogAlert = true; 
            this.close();
            this.reopenEdition = true; 
            return false;
          } else if (!response.success && response.message) {
            this.alertMessage = this.$t('page.series.error_general');
            if(Array.isArray(response.message) && response.message.length > 0) {
              this.alertMessage = this.$t('common.request.'+response.message[0], { field: this.$t('page.series.group_option') });
            } else if(typeof response.message == 'string') {
              this.alertMessage = this.$t('common.request.'+response.message, { field: this.$t('page.series.group_option') })
            }
            this.dialogAlert = true; 
            this.close();
            this.reopenEdition = true; 
            return false;
          }

          this.getRecords();
          this.close();
        } else { 
          this.alertMessage = this.$t('page.series.error_general');
          this.dialog = false;
          this.dialogAlert = true;
          this.reopenEdition = true; 
        }
      }

    },
    closeAlert(){
      this.dialogAlert=false;
      if(this.reopenEdition){
        this.dialog = true;
      }
    },
  }
};
</script>

<style scoped>
.v-application .headline {
  font-size: 24px !important;
}
.v-dialog > .v-card > .v-card__text {
    padding: 0 40px 20px;
}
.v-card__actions .v-btn {
    background-color: var(--v-primary-darken2) !important;
    color: white !important;
}
.v-text-field.v-text-field--enclosed {
    padding-top: 12px;
    margin-top: 4px;
}
</style>
